import { useCallback, useState } from 'react';
import { AccountingModalName, AccountingModalsState } from '../../interfaces/ProjectInterface';

const defaultModals: AccountingModalsState = {
  task: false,
  archive: false,
  milestone: false,
  project: false,
  confirmation: false
};

export const useAccountingModals = () => {
  const [modals, setModals] = useState<AccountingModalsState>(defaultModals);

  const openModal = useCallback((modalName: AccountingModalName) => {
    setModals((currentModals) => ({ ...currentModals, [modalName]: true }));
  }, []);

  const closeModal = useCallback((modalName: AccountingModalName) => {
    setModals((currentModals) => ({ ...currentModals, [modalName]: false }));
  }, []);

  const closeProjectModals = useCallback(() => {
    setModals((currentModals) => ({
      ...currentModals,
      project: false,
      confirmation: false
    }));
  }, []);

  return {
    modals,
    openModal,
    closeModal,
    closeProjectModals
  };
};
